module.exports = __webpack_public_path__ + "static/img/标准直齿锥齿轮的计算.3ea8dfd7.jpg";